import { Stack } from "@mui/material";
import { DetailBoxWrapper } from "../DetailBoxWrapper/DetailBoxWrapper";
import React from "react";

export type TitleDatailInlineProps = { title?: string; detail?: React.ReactNode };

export const TitleDatailInline = ({ title, detail }: TitleDatailInlineProps) => {
  return (
    <Stack sx={{ overflow: "hidden" }} direction="row" spacing={2} justifyContent={"space-between"} display={"flex"}>
      <DetailBoxWrapper
        sx={{
          fontSize: "0.875rem",
          fontWeight: 500,
          color: "text.secondary",
        }}
      >
        {title}
      </DetailBoxWrapper>
      <DetailBoxWrapper
        sx={{
          fontSize: "1.125rem",
          fontWeight: 500,
          textAlign: "right",
        }}
      >
        {detail}
      </DetailBoxWrapper>
    </Stack>
  );
};
